/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';

export const NEW_COMPASS_PROJECTS_ENABLED_KEY = 'jira.admin.compass.is-enabled-for-new-project';
